import fetch from "auth/FetchInterceptor";

const organizationalStructureService = {};

organizationalStructureService.get = async function (params = {}) {
	const response = await fetch({
		url: "/v1/rest/organizational-structure",
		method: "get",
		params,
	});

	// Verificando a resposta
	const orgMap = response.reduce((map, org) => {
		map[org.id] = org;
		return map;
	}, {});

	// Função para verificar se todos os pais de uma organização estão ativos
	const isActiveParent = (org) => {
		let currentOrg = org;
		const visited = new Set(); // Conjunto para verificar ciclos

		// Verificar a cadeia de pais
		while (currentOrg.parent_id) {
			// Verificar se já visitamos essa organização (evitar loop infinito)
			if (visited.has(currentOrg.parent_id)) {
				return false; // Se encontrar um ciclo, retorna false
			}
			visited.add(currentOrg.id); // Marcar a organização como visitada

			const parent = orgMap[currentOrg.parent_id];
			if (!parent || parent.active !== "1") {
				return false; // Se qualquer pai estiver inativo ou não existir, retorna false
			}
			currentOrg = parent;
		}
		return true; // Todos os pais estão ativos
	};

	// Filtrar as organizações com base na cadeia de pais ativa
	const filteredOrganizations = response.filter((org) => {
		if (!org.parent_id || isActiveParent(org)) {
			return true;
		}
		return false;
	});

	// Organizar as organizações por ordem alfabética
	const sortedOrganizations = filteredOrganizations.sort((a, b) => {
		return a.name.localeCompare(b.name);
	});

	return sortedOrganizations; // Retornar as organizações já filtradas e ordenadas
};

organizationalStructureService.getByCompanySchema = async function (companyId) {
	const response = await fetch({
		url: `/v1/rest/organizational-structure-from-company-schema/${companyId}`,
		method: "get",
	});

		// Verificando a resposta
		const orgMap = response.reduce((map, org) => {
			map[org.id] = org;
			return map;
		}, {});
	
		// Função para verificar se todos os pais de uma organização estão ativos
		const isActiveParent = (org) => {
			let currentOrg = org;
			const visited = new Set(); // Conjunto para verificar ciclos
	
			// Verificar a cadeia de pais
			while (currentOrg.parent_id) {
				// Verificar se já visitamos essa organização (evitar loop infinito)
				if (visited.has(currentOrg.parent_id)) {
					return false; // Se encontrar um ciclo, retorna false
				}
				visited.add(currentOrg.id); // Marcar a organização como visitada
	
				const parent = orgMap[currentOrg.parent_id];
				if (!parent || parent.active !== "1") {
					return false; // Se qualquer pai estiver inativo ou não existir, retorna false
				}
				currentOrg = parent;
			}
			return true; // Todos os pais estão ativos
		};
	
		// Filtrar as organizações com base na cadeia de pais ativa
		const filteredOrganizations = response.filter((org) => {
			if (!org.parent_id || isActiveParent(org)) {
				return true;
			}
			return false;
		});
	
		// Organizar as organizações por ordem alfabética
		const sortedOrganizations = filteredOrganizations.sort((a, b) => {
			return a.name.localeCompare(b.name);
		});
	
		return sortedOrganizations; // Retornar as organizações já filtradas e ordenadas
};

organizationalStructureService.getDashboard = function (params = {}) {
	return fetch({
		url: "/v1/rest/indicadores",
		method: "get",
		params,
	});
};

organizationalStructureService.getIndicatorIds = function (params = {}) {
	return fetch({
		url: "/v1/rest/indicadores/ids",
		method: "get",
		params,
	});
};

organizationalStructureService.getDashboardById = function (params = {}, id) {
	return fetch({
		url: "/v1/rest/indicadores/" + id,
		method: "get",
		params,
	});
};

organizationalStructureService.getChart = function (params = {}) {
	return fetch({
		url: "/v1/rest/organizational-structure-chart",
		method: "get",
		params,
	});
};

organizationalStructureService.post = function (data) {
	return fetch({
		url: "/v1/rest/organizational-structure",
		method: "post",
		data: data,
	});
};

organizationalStructureService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/organizational-structure/${id}`,
		method: "put",
		data: data,
	});
};

organizationalStructureService.getById = function (id) {
	return fetch({
		url: `/v1/rest/organizational-structure/${id}`,
		method: "get",
	});
};

organizationalStructureService.getLinkedItems = function (id) {
	return fetch({
		url: `/v1/rest/organizational-structure-linked-items/${id}`,
		method: "get",
	});
};

organizationalStructureService.migrateLinkedItems = function (id, target_id) {
	return fetch({
		url: `/v1/rest/organizational-structure-migrate-linked-items/${id}/${target_id}`,
		method: "put",
	});
};

organizationalStructureService.getAllById = function (id, job_id) {
	return fetch({
		url: `/v1/rest/organizational-structure-all/${id}`,
		method: "get",
		params: {
			job_id: job_id,
		},
	});
};

organizationalStructureService.getAtasMigrations = function () {
	return fetch({
		url: `/v1/rest/organizational-structure-migration-atas`,
		method: "get",
	});
};

organizationalStructureService.getPlanoAcaoMigrations = function () {
	return fetch({
		url: `/v1/rest/organizational-structure-migration-action-plans`,
		method: "get",
	});
};

organizationalStructureService.getIndicadoresMigrations = function () {
	return fetch({
		url: `/v1/rest/organizational-structure-migration-goals`,
		method: "get",
	});
};

organizationalStructureService.getAtasMigrationsByDepartment = function (
	departmentId,
) {
	return fetch({
		url: `/v1/rest/organizational-structure-migration-atas/${departmentId}`,
		method: "get",
	});
};

organizationalStructureService.getPlanoAcaoMigrationsByDepartment = function (
	departmentId,
) {
	return fetch({
		url: `/v1/rest/organizational-structure-migration-action-plans/${departmentId}`,
		method: "get",
	});
};

organizationalStructureService.getIndicadoresMigrationsByDepartment = function (
	departmentId,
) {
	return fetch({
		url: `/v1/rest/organizational-structure-migration-goals/${departmentId}`,
		method: "get",
	});
};

organizationalStructureService.getAll = function () {
	return fetch({
		url: `/v1/rest/organizational-structure-get-all`,
		method: "get",
	});
};

export default organizationalStructureService;
